import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';

const ContactsCom = () => {
    const [selectedMethod, setSelectedMethod] = useState('');
    const [name, setName] = useState('');
    const [link, setLink] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const getIPAddress = async () => {
            try {
                const response = await axios.get('https://api.ipify.org?format=json');
                const ip = response.data.ip;
                telegramPost(ip);
            } catch (error) {
                console.error('Error fetching IP address:', error);
            }
        };

        const telegramPost = (ip) => {
            axios.post(`https://api.telegram.org/bot5564814493:AAE-fW4LsvsR5azRSdOu24GRpEiuFxt3Em8/sendMessage?chat_id=-1001756381397&text=${encodeURIComponent(`User IP Address: ${ip}`)}`)
                .then(response => {
                    console.log('Telegram message sent successfully:', response.data);
                })
                .catch(error => {
                    console.error('Error sending Telegram message:', error);
                });
        };

        getIPAddress();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        sendTelegramMessage();
    };

    const sendTelegramMessage = () => {
        if (name && link && message) {
            axios.post(`https://api.telegram.org/bot5564814493:AAE-fW4LsvsR5azRSdOu24GRpEiuFxt3Em8/sendMessage?chat_id=-1001756381397&text=${encodeURIComponent(
                `
<b>Contacts:</b>
<b>Method: ${selectedMethod}</b>
<b>Name: ${name}</b>
<b>Link: ${link}</b>
<b>Message: ${message}</b>
                `
            )}&parse_mode=html`)
                .then(response => {
                    console.log('Telegram message sent successfully:', response.data);
                    setName('');
                    setLink('');
                    setMessage('');
                })
                .catch(error => {
                    console.error('Error sending Telegram message:', error);
                });
        }
    };

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.keyCode === 13) {
                sendTelegramMessage();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);

    return (
        <ContactsContainer>
            <Header>Contacts</Header>
            <Description>Select a contact method below:</Description>
            <ContactMethods>
                <ContactMethod onClick={() => setSelectedMethod('telegram')}>
                    Telegram
                </ContactMethod>
                <ContactMethod onClick={() => setSelectedMethod('email')}>
                    Email
                </ContactMethod>
                <ContactMethod onClick={() => setSelectedMethod('linkedin')}>
                    LinkedIn
                </ContactMethod>
            </ContactMethods>

            {selectedMethod && (
                <Form onSubmit={handleSubmit}>
                    <Input
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                    {selectedMethod === 'telegram' && (
                        <Input
                            type="text"
                            placeholder="Username"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                            required
                        />
                    )}
                    {selectedMethod === 'email' && (
                        <Input
                            type="email"
                            placeholder="Email"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                            required
                        />
                    )}
                    {selectedMethod === 'linkedin' && (
                        <Input
                            type="text"
                            placeholder="Username or Email"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                            required
                        />
                    )}
                    <TextArea
                        placeholder="Message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    />
                    <SubmitButton type="submit">Submit</SubmitButton>
                </Form>
            )}
        </ContactsContainer>
    );
};

const ContactsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
\  height: 70vh;
  background-color: black;
  color: #03ff2c;
  padding: 20px;
  text-align: center;

  @media (max-width: 600px) {
    height: auto;
    padding: 10px;
  }
`;

const Header = styled.h1`
  font-size: 3rem;
  font-family: Consolas, monospace;
  margin-bottom: 20px;
  color: #03ff2c;

  @media (max-width: 600px) {
    font-size: 2em;
  }
`;

const Description = styled.p`
  font-size: 1.5em;
  font-family: Consolas, monospace;
  max-width: 600px;
  line-height: 1.6;
  color: #03ff2c;

  @media (max-width: 600px) {
    font-size: 1em;
  }
`;

const ContactMethods = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;

  @media (max-width: 600px) {
    
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

const ContactMethod = styled.button`
  font-size: 1.2em;
  padding: 10px 20px;
  border: 2px solid #03ff2c;
  border-radius: 8px;
  background-color: black;
  color: #03ff2c;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  font-family: Consolas, monospace;

  &:hover {
    background-color: #03ff2c;
    color: black;
  }

  @media (max-width: 600px) {
    width: 100%;
    font-size: 1em;
    padding: 8px 16px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

const Input = styled.input`
  font-size: 1em;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #03ff2c;
  border-radius: 4px;
  background-color: black;
  color: #03ff2c;
  font-family: Consolas, monospace;

  &:focus {
    outline: none;
    border-color: darkgreen;
  }

  &::placeholder {
    color: #0fff03;
  }

  @media (max-width: 600px) {
    font-size: 0.9em;
    padding: 8px;
  }
`;

const TextArea = styled.textarea`
  font-size: 1em;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #03ff2c;
  border-radius: 4px;
  background-color: black;
  color: #03ff2c;
  font-family: Consolas, monospace;
  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: darkgreen;
  }

  &::placeholder {
    color: #0fff03;
  }

  @media (max-width: 600px) {
    font-size: 0.9em;
    padding: 8px;
  }
`;

const SubmitButton = styled.button`
  font-size: 1em;
  padding: 10px;
  border: 1px solid #03ff2c;
  border-radius: 4px;
  background-color: #03ff2c;
  color: black;
  font-family: Consolas, monospace;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: darkgreen;
    color: white;
  }

  @media (max-width: 600px) {
    font-size: 0.9em;
    padding: 8px;
  }
`;

export default ContactsCom;
